import { BadgeList, IconList, Badge } from 'ui';
import * as React from 'react';
import { BadgeProps } from 'ui/badge/badge';
import styles from './fact-box.scss';
import * as navigate from 'app/area/shared/navigation';
import { FactboxItemProps, FactBoxProps } from 'app/area/case/components/fact-box/types';
import { Link } from 'react-router-dom';

const Fact = ({classNames='',section, children, url}) => {
  return section || url ? <Link className={`${styles.factItem} ${classNames} fact-item`}
            to={navigate.toSectionURL(section,url)}>
            {children}
        </Link> : <div className={`${styles.factItem} ${classNames} fact-item`}>
          {children}
        </div>;
};

interface FactBadgeListProps {
  icon: JSX.Element;
  title: string;
  valueItems: FactboxItemProps[];
  classNames?: string;
  useNestedIndicator?: boolean;
  section?:number;
  factProps?: FactBoxProps;
}

export const FactBadgeList = ({
  icon,
  title,
  valueItems,
  classNames,
  useNestedIndicator,
  section,
  factProps}:FactBadgeListProps
) => <Fact classNames={classNames || ''} section={section} url={factProps ? factProps.url : undefined}>
      <BadgeList
        icon={icon}
        title={title}
        valueItems={valueItems}
        useNestedIndicator={useNestedIndicator}
      />
    </Fact>;

interface FactIconListProps {
  title: string;
  icons: FactboxItemProps[];
  defaultIcon?: any;
  section?:number;
  url:string;
  iconLine?: boolean;
  [key: string]: any;
}
export const FactIconList = (
  {title, iconLine, icons,defaultIcon, section, url}: FactIconListProps
) => {
  return (
    <Fact classNames={iconLine ? styles.iconLine : ''} section={section} url={url}>
      <IconList title={title} valueItems={icons as any} defaultIcon={defaultIcon} />
    </Fact>
  );
};

interface FactBadgeProps {
  badgeProps: BadgeProps;
  section?: number;
  [key: string]: any;
}
export const FactBadge = ({badgeProps, section, url}:FactBadgeProps) => {
  return (
    <Fact section={section} url={url}>
      <Badge
        {...badgeProps}
      />
    </Fact>
  );
};
